export default {
  title: 'Acțiuni rapide',
  send_push_notification: {
    label: 'Trimiteți notificare push',
    description: 'Creați o campanie nouă',
  },
  email_campaign: {
    label: 'Campanie prin e-mail',
    description: 'Trimiteți abonaților',
  },
  view_analytics: {
    label: 'Vezi analize',
    description: 'Performanța campaniei',
  },
};
